import React, { useEffect, useRef, useState } from 'react';
import { translate } from '../Services/translation';

const CheckoutPopUp = ({ loginPageUrl, registrationUrl }) => {
    const [isVisible, setIsVisible] = useState(true);
    const popupRef = useRef(null);

    const handlePopupClose = () => {
      setIsVisible(false);
    };

    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            handlePopupClose();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    const renderContent = () => {
      if (isVisible) {
        return (
          <div className="checkout-pop-up">
            <div className="checkout-pop-up__content" ref={popupRef}>
              <div className="checkout-pop-up__close" onClick={handlePopupClose}></div>
              <div className="checkout-pop-up__text-wrapper">
                <h2 className="checkout-pop-up__title">
                  {translate('coptikk.checkout.login.title')}
                </h2>
                <p className="checkout-pop-up__text">
                  {translate('coptikk.checkout.login.description')}
                </p>
              </div>
              <div className="checkout-pop-up__buttons-wrapper">
                <a href={loginPageUrl} className="login-button">{translate('coptikk.checkout.login.button')}</a>
                <p className="register-text">{translate('coptikk.checkout.register.description')}</p>
                <a href={registrationUrl} className="register-button">{translate('coptikk.checkout.register.button')}</a>
              </div>
            </div>
          </div>
        );
      } else {
        return (
        <div className="row checkout-login-message">
            <div className='checkout-login-message__text-wrapper'>
                <h2 className="title">
                  {translate('coptikk.checkout.login.title')}
                </h2>
                <p className="text">
                  {translate('coptikk.checkout.login.description')}
                </p>
            </div>
            <div className='checkout-login-message__button-wrapper'>
                <a href={loginPageUrl} className="login-button">{translate('coptikk.checkout.login.button')}</a>
                <div className='register-row'>
                    <p className="register-text">{translate('coptikk.checkout.register.description')}</p>
                    <a href={registrationUrl} className="register-button">{translate('coptikk.checkout.register.button')}</a>
                </div>
            </div>
        </div>
        );
      }
    };
  
    return renderContent();
  };

export default CheckoutPopUp;